module.exports = new __parcel__URL__("Charlie_Display-Ultra.fdc197e1.woff2").toString();